import * as baja from "@nwebui/bajascript";

export class NiagaraClient {
  static readonly INSTANCE = new NiagaraClient();

  private NiagaraClient() {}

  async username(): Promise<string> {
    const resp = await fetch("/wb/logon", {
      credentials: "include",
      cache: "no-cache",
      redirect: "manual",
    });
    if (!resp.ok) {
      return "";
    }
    const body = await resp.text();
    const opt = parseWbLogon(body);
    return opt.username || "";
  }

  async loginScheme(): Promise<string | undefined> {
    const resp = await fetch("/login");
    const body = await resp.text();
    const match = body.match(/id='scheme' value='(\w+)'/);
    if (match) {
      return match[1];
    }
  }

  async loginCookie(username: string, password: string): Promise<boolean> {
    const token = btoa(username + ":" + password);
    const resp = await fetch("/login", {
      method: "POST",
      body: `scheme=cookie&token=${token}`,
      credentials: "include",
      cache: "no-cache",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
    });
    const body = await resp.text();
    return !body.includes("/login");
  }

  async login(username: string, password: string): Promise<boolean> {
    const scheme = await this.loginScheme();
    if (scheme === "cookie") {
      return this.loginCookie(username, password);
    }
    const auth = new baja.Authenticator("", username, password);
    await auth.authenticate();
    return true;
  }

  async logout(): Promise<void> {
    await fetch("/logout", {
      credentials: "include",
      cache: "no-cache",
    });
  }

  async downloadFile(ord: string, cache?: RequestCache): Promise<string> {
    const url = "/file/" + ord.replace(/^(local:\|)?file:\^/, "");
    const resp = await fetch(url, {
      credentials: "include",
      cache,
    });
    if (!resp.ok) {
      throw new Error(resp.statusText);
    }
    return await resp.text();
  }

  async openAlarms(): Promise<AlarmRecord[]> {
    const url = "/api/alarm/open";
    const resp = await fetch(url, {
      credentials: "include",
    });
    return (await resp.json()).result;
  }

  async ackAlarms(uuids: string[]): Promise<any> {
    const url = "/api/alarm/ack";
    await fetch(url, {
      credentials: "include",
      method: "POST",
      body: JSON.stringify(uuids),
    });
    return;
  }

  async forceClearAlarms(uuids: string[]): Promise<any> {
    const url = "/api/alarm/forceclear";
    await fetch(url, {
      credentials: "include",
      method: "POST",
      body: JSON.stringify(uuids),
    });
    return;
  }

  async histories(): Promise<any[]> {
    return [];
  }

  async numericTrends(sort: boolean): Promise<any[]> {
    const resp = await fetch("/api/history/numerictrends", {
      credentials: "include",
    });
    const trends = (await resp.json()).result;
    if (sort) {
      // trends = sortBy(trends, "name");
    }
    return trends;
  }

  async queryTrend(option: {
    id: string;
    start?: Date;
    end?: Date;
    descending?: boolean;
    filter?: boolean;
    limit?: number;
  }): Promise<any[]> {
    const params = new URLSearchParams();
    params.set("id", option.id);
    if (option.start) {
      params.set("start", "" + option.start.valueOf());
    }
    if (option.end) {
      params.set("end", "" + option.end.valueOf());
    }
    if (option.descending != null) {
      params.set("desc", "" + option.descending);
    }
    if (option.filter != null) {
      params.set("filter", "" + option.filter);
    }
    if (option.limit != null) {
      params.set("limit", "" + option.limit);
    }
    const url = `/api/history/querytrend?${params}`;
    const resp = await fetch(url, {
      credentials: "include",
    });
    const result = (await resp.json()).result;
    result.forEach(function (x) {
      x[0] = x[0] * 1000;
    });
    return result;
  }
}

function parseWbLogon(text: string): { [k: string]: string } {
  const o = {};
  text.split("\n").forEach((line) => {
    const i = line.indexOf("=");
    if (i > 0) {
      o[line.substring(0, i)] = line.substr(i + 1).trim();
    }
  });
  return o;
}

export class NavNode {
  name = "";
  icon = "";
  ord = "";
  children: NavNode[] = [];
}

function parseNav(body: string): NavNode {
  const parser = new DOMParser();
  const xmldoc = parser.parseFromString(body, "text/xml");
  return parseNode(xmldoc.documentElement!.firstElementChild!);
}

function parseNode(node: Element): NavNode {
  const navNode = new NavNode();
  navNode.name = node.getAttribute("name") || "";
  navNode.icon = node.getAttribute("icon") || "";
  navNode.ord = node.getAttribute("ord") || "";
  navNode.children = [];
  for (
    let child = node.firstElementChild;
    child;
    child = child.nextElementSibling
  ) {
    navNode.children.push(parseNode(child));
  }
  return navNode;
}

export interface AlarmRecord {
  uuid: string;
  ackRequired: boolean;
  ackState: string;
  ackTime: number;
  alarmClass: string;
  alarmData: AlarmData;
  alarmTransition: string;
  lastUpdate: number;
  normalTime: number;
  priority: number;
  source: string;
  sourceState: string;
  timestamp: number;
  user: string;
}

export interface AlarmData {
  hyperlinkOrd: string;
  sourceName: string;
  msgText: string;
}
